import {GET_CANDIDATE_INTERVIEW_LIST_DETAILS ,GET_CANDIDATE_INTERVIEW_LIST_DETAILS_SUCCESS,GET_CANDIDATE_INTERVIEW_LIST_DETAILS_FAIL} from './actionTypes'

export const getCandidateInterviewList = (jsonData)=>{
    return {
        type: GET_CANDIDATE_INTERVIEW_LIST_DETAILS,
        payload: {jsonData}
    }
} 

export const getCandidateInterviewListSuccess = (jsonData)=>{
    return {
        type: GET_CANDIDATE_INTERVIEW_LIST_DETAILS_SUCCESS,
        payload: {jsonData}
    }
} 

export const getCandidateInterviewListFail = (jsonData)=>{
    return {
        type: GET_CANDIDATE_INTERVIEW_LIST_DETAILS_FAIL,
        payload: {jsonData}
    }
} 
